import { createContext } from 'react'

export interface FilterValues {
  [key: string]: string
}

export interface PaginationData {
  filters?: FilterValues
  page: number
  searchQuery?: string
  size: number
  sort?: string
  totalElements?: number
  totalPages?: number
  results?: []
}

export interface PaginationContextType {
  setPaginationData: (data: PaginationData) => void
  getPaginationData: (key: string) => PaginationData
  updateQueryParams: (data: PaginationData) => void
  resetPaginationData: () => void
}

const PaginationContext = createContext<PaginationContextType | undefined>(
  undefined,
)

export default PaginationContext
